module.exports = __webpack_public_path__ + "static/img/rank-bg.5a9954dc.png";